import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {REGISTRATION_WIZARD_TEST_IDS} from "@pg-mono/test-ids";

import {facebookAppId} from "../../../app/read_rp_environment_variables";
import type {IFacebookResponse} from "../../types/IFacebookResponse";
import {FacebookAuth} from "../auth_card/FacebookAuth";

const facebookIcon = require("../../images/facebook_icon.svg");

const FACEBOOK_BUTTON_LABEL = "Kontynuuj z Facebook";
const googleIcon = require("../../images/google_icon.svg");

interface IProps {
    onGoogleClick: () => void;
    onFacebookClick: () => void;
    onFacebookResponse: (response: IFacebookResponse) => void;
}

export const RegistrationWizardSocialButtons = (props: IProps) => {
    const {onGoogleClick, onFacebookClick, onFacebookResponse} = props;

    return (
        <div className={socialRowStyle}>
            <button
                type="button"
                aria-label="Kontynuuj z Google"
                className={cx(socialButtonStyle, googleOrderStyle)}
                onClick={onGoogleClick}
                data-testid={REGISTRATION_WIZARD_TEST_IDS.GOOGLE_BUTTON}
            >
                <img src={googleIcon} alt="" width={24} height={24} />
                <Text as="span" variant="info_txt_1" className={socialLabelStyle}>
                    Kontynuuj z Google
                </Text>
            </button>

            {!!facebookAppId && (
                <div className={cx(socialButtonStyle, facebookOrderStyle, facebookOverlayStyle)} data-testid={REGISTRATION_WIZARD_TEST_IDS.FACEBOOK_BUTTON}>
                    <span aria-hidden="true" className={facebookContentStyle}>
                        <img src={facebookIcon} alt="" width={24} height={24} />
                        <Text as="span" variant="info_txt_1" className={socialLabelStyle}>
                            {FACEBOOK_BUTTON_LABEL}
                        </Text>
                    </span>
                    <FacebookAuth
                        appId={facebookAppId as string}
                        buttonText={FACEBOOK_BUTTON_LABEL}
                        className="facebookAuthButton"
                        callback={onFacebookResponse}
                        onClick={onFacebookClick}
                    />
                </div>
            )}
        </div>
    );
};

const socialRowStyle = css({
    display: "flex",
    columnGap: 0.5,
    md: {
        columnGap: 2
    }
});

const socialButtonStyle = css({
    position: "relative",
    flex: "1 1 0",
    minWidth: 0,
    height: "4.8rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    columnGap: 2,
    px: 2,
    border: "1px solid var(--colors-gray-300)",
    borderRadius: 2,
    backgroundColor: "var(--colors-gray-100)",
    color: "var(--colors-secondary)",
    cursor: "pointer",
    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    },
    md: {
        justifyContent: "flex-start"
    }
});

const googleOrderStyle = css({
    order: 0,
    md: {
        order: 1
    }
});

const facebookOrderStyle = css({
    order: 1,
    md: {
        order: 0
    }
});

const facebookContentStyle = css({
    display: "contents"
});

const socialLabelStyle = css({
    display: "none",
    md: {
        display: "inline",
        whiteSpace: "nowrap"
    }
});

const facebookOverlayStyle = css({
    "& .facebookAuthButton": {
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "transparent",
        border: "none",
        borderRadius: "inherit",
        color: "transparent",
        fontSize: 0,
        cursor: "pointer",

        "&:focus": {
            outline: 0
        },

        "&:focus-visible": {
            outline: "2px solid var(--colors-secondary)",
            outlineOffset: "2px"
        }
    }
});
import {css, cx} from "@panda/css";

import {Text} from "@pg-design/text-module";
import {REGISTRATION_WIZARD_TEST_IDS} from "@pg-mono/test-ids";

import {facebookAppId} from "../../../app/read_rp_environment_variables";
import type {IFacebookResponse} from "../../types/IFacebookResponse";
import {FacebookAuth} from "../auth_card/FacebookAuth";

const facebookIcon = require("../../images/facebook_icon.svg");

const FACEBOOK_BUTTON_LABEL = "Kontynuuj z Facebook";
const googleIcon = require("../../images/google_icon.svg");

interface IProps {
    onGoogleClick: () => void;
    onFacebookClick: () => void;
    onFacebookResponse: (response: IFacebookResponse) => void;
}

export const RegistrationWizardSocialButtons = (props: IProps) => {
    const {onGoogleClick, onFacebookClick, onFacebookResponse} = props;

    return (
        <div className={socialRowStyle}>
            <button
                type="button"
                aria-label="Kontynuuj z Google"
                className={cx(socialButtonStyle, googleOrderStyle)}
                onClick={onGoogleClick}
                data-testid={REGISTRATION_WIZARD_TEST_IDS.GOOGLE_BUTTON}
            >
                <img src={googleIcon} alt="" width={24} height={24} />
                <Text as="span" variant="info_txt_1" className={socialLabelStyle}>
                    Kontynuuj z Google
                </Text>
            </button>

            {!!facebookAppId && (
                <div className={cx(socialButtonStyle, facebookOrderStyle, facebookOverlayStyle)} data-testid={REGISTRATION_WIZARD_TEST_IDS.FACEBOOK_BUTTON}>
                    <span aria-hidden="true" className={facebookContentStyle}>
                        <img src={facebookIcon} alt="" width={24} height={24} />
                        <Text as="span" variant="info_txt_1" className={socialLabelStyle}>
                            {FACEBOOK_BUTTON_LABEL}
                        </Text>
                    </span>
                    <FacebookAuth
                        appId={facebookAppId as string}
                        buttonText={FACEBOOK_BUTTON_LABEL}
                        className="facebookAuthButton"
                        callback={onFacebookResponse}
                        onClick={onFacebookClick}
                    />
                </div>
            )}
        </div>
    );
};

const socialRowStyle = css({
    display: "flex",
    columnGap: 0.5,
    md: {
        columnGap: 2
    }
});

const socialButtonStyle = css({
    position: "relative",
    flex: "1 1 0",
    minWidth: 0,
    height: "4.8rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    columnGap: 2,
    px: 2,
    border: "1px solid var(--colors-gray-300)",
    borderRadius: 2,
    backgroundColor: "var(--colors-gray-100)",
    color: "var(--colors-secondary)",
    cursor: "pointer",
    _focusVisible: {
        outline: "2px solid var(--colors-secondary)",
        outlineOffset: "2px"
    },
    md: {
        justifyContent: "flex-start"
    }
});

const googleOrderStyle = css({
    order: 0,
    md: {
        order: 1
    }
});

const facebookOrderStyle = css({
    order: 1,
    md: {
        order: 0
    }
});

const facebookContentStyle = css({
    display: "contents"
});

const socialLabelStyle = css({
    display: "none",
    md: {
        display: "inline",
        whiteSpace: "nowrap"
    }
});

const facebookOverlayStyle = css({
    "& .facebookAuthButton": {
        position: "absolute",
        inset: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "transparent",
        border: "none",
        borderRadius: "inherit",
        color: "transparent",
        fontSize: 0,
        cursor: "pointer",

        "&:focus": {
            outline: 0
        },

        "&:focus-visible": {
            outline: "2px solid var(--colors-secondary)",
            outlineOffset: "2px"
        }
    }
});
